import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../components/Layout/MainLayout';
import DataCenterCard from '../../../components/Dashboard/DataCenterCard';
import { BackIcon, RegularRDCIcon, RDEIcon } from '../../../components/Dashboard/DataCenterIcons';
import '../../../assets/styles/VDCPage.css';
import { ROUTES } from '../../../utils/constants';

const VDCPage: React.FC = () => {
  const navigate = useNavigate();
  const handleCardClick = (path = "", isEnabled = false) => { // Fixed parameter name
    console.log('Card clicked - path:', path, 'isEnabled:', isEnabled); // Debug log
    if (isEnabled && path) {
      navigate(path);
    }
    // If disabled, do nothing
  };
  const vdcTypes = [
    {
      id: 'regular-vdc',
      title: 'Regular VDC',
      icon: <RegularRDCIcon />,
      path: ROUTES.VDC_REGULAR,
      enabled: true,
    },
    {
      id: 'fdc-upload',
      title: 'FDC Upload',
      icon: <RDEIcon />,
      path: ROUTES.VDC_FDC,
      enabled: true,
    },
    {
      id: 'rsc-upload',
      title: 'RSC Upload',
      icon: <RDEIcon />,
      path: ROUTES.VDC_RSC,
      enabled: false,
      disabledMessage:"Under Development"
    },
  ];

  return (
    <MainLayout>
      <div className="vdc-page">
        {/* Back Button */}
        <div className="vdc-back-button-container">
          <button
            onClick={() => navigate(-1)}
            className="vdc-back-button"
          >
            <BackIcon />
            Back
          </button>
        </div>

        {/* Main Content */}
        <div className="vdc-grid">
          {vdcTypes.map((type) => (
            <DataCenterCard
              key={type.id}
              title={type.title}
              icon={type.icon}
              // onClick={() => navigate(type.path)}
              onClick={() => handleCardClick(type.path, type.enabled)} // Pass dc.enabled directly
              isEnabled={type.enabled}
              disabledMessage={type.disabledMessage}
            />
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default VDCPage;
